var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":_vm.text}},on),[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-cancel")]),_vm._v(" "+_vm._s(_vm.label || _vm.$t('no-permission-button.no-permission'))+" ")],1)]}}])},[_c('span',[_vm._v(_vm._s(_vm.$t('no-permission-button.insufficient-permission')))])])}
var staticRenderFns = []

export { render, staticRenderFns }